module.exports = __webpack_public_path__ + "images/81f234d781bad8ae9963f08b956d83de048aff8ffef45c744d73b818ea63f410.svg";